import BasePlugin from '@flamingo_tech/funkgo/src/base/BasePlugin'

export default class LifeCyclePlugin extends BasePlugin {
  displayName = '$LifeCycle'

  getComponent(name) {
    return this.options[name]
  }
}